export const HOME_TAB = 'home';
export const STOPWATCH_TAB = 'stopwatch';
